define.alias("ember-math-helpers/helpers/log-e", "preview-grid/helpers/log-e");